<div class="info-accordion ice-info-accordion {{ type }}">
  <app-info-accordion-header
    tab="0"
    [displayIcon]="displayIcon"
    [icon]="iconName ?? IconNames.ice_circle_wave"
    [isOpen]="isOpen"
    [testId]="testId()"
    [type]="type"
    (toggleInfoAccordion)="isOpen = !isOpen"
  >
    <ng-content select="[header]" />
  </app-info-accordion-header>
  <app-info-accordion-content [isOpen]="isOpen">
    <ng-content select="[content]" />
  </app-info-accordion-content>
</div>
